// extracted by mini-css-extract-plugin
export default {"hideTooltip":"faa-z","fadeIn":"gaa-z","delay":"haa-z","recommendedSizeTooltip":"iaa-z"};